var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6001 8.00005C1.6001 7.66868 1.86873 7.40005 2.2001 7.40005L12.2722 7.40005L10.5918 5.83973C10.349 5.61425 10.3349 5.23461 10.5604 4.99178C10.7859 4.74895 11.1655 4.73489 11.4084 4.96038L14.2084 7.56038C14.3306 7.6739 14.4001 7.83321 14.4001 8.00005C14.4001 8.16689 14.3306 8.3262 14.2084 8.43973L11.4084 11.0397C11.1655 11.2652 10.7859 11.2511 10.5604 11.0083C10.3349 10.7655 10.349 10.3859 10.5918 10.1604L12.2722 8.60005L2.2001 8.60005C1.86873 8.60005 1.6001 8.33142 1.6001 8.00005Z",
    fill: "#4D5788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongRight);
export default __webpack_public_path__ + "static/media/ArrowLongRight.b753b9f77f54db216219806cacf4ee11.svg";
export { ForwardRef as ReactComponent };